
<template>
    <svg v-if="!ext" width="40" height="40" viewBox="0 0 50 50" fill="#B5C1D2" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.33398 5V4C7.7817 4 7.33398 4.44772 7.33398 5H8.33398ZM31.6673 35V36C32.2196 36 32.6673 35.5523 32.6673 35H31.6673ZM8.33398 35H7.33398C7.33398 35.5523 7.7817 36 8.33398 36V35ZM23.334 5L24.0411 4.29289C23.8536 4.10536 23.5992 4 23.334 4V5ZM31.6673 13.3333H32.6673C32.6673 13.0681 32.562 12.8138 32.3744 12.6262L31.6673 13.3333ZM13.334 27.3333C12.7817 27.3333 12.334 27.781 12.334 28.3333C12.334 28.8856 12.7817 29.3333 13.334 29.3333V27.3333ZM26.6673 29.3333C27.2196 29.3333 27.6673 28.8856 27.6673 28.3333C27.6673 27.781 27.2196 27.3333 26.6673 27.3333V29.3333ZM13.334 20.6667C12.7817 20.6667 12.334 21.1144 12.334 21.6667C12.334 22.219 12.7817 22.6667 13.334 22.6667V20.6667ZM23.334 22.6667C23.8863 22.6667 24.334 22.219 24.334 21.6667C24.334 21.1144 23.8863 20.6667 23.334 20.6667V22.6667ZM31.6673 34H8.33398V36H31.6673V34ZM9.33398 35V5H7.33398V35H9.33398ZM8.33398 6H23.334V4H8.33398V6ZM30.6673 13.3333V35H32.6673V13.3333H30.6673ZM22.6269 5.70711L30.9602 14.0404L32.3744 12.6262L24.0411 4.29289L22.6269 5.70711ZM20.6673 5V11.6667H22.6673V5H20.6673ZM25.0007 16H31.6673V14H25.0007V16ZM20.6673 11.6667C20.6673 14.0599 22.6074 16 25.0007 16V14C23.712 14 22.6673 12.9553 22.6673 11.6667H20.6673ZM13.334 29.3333H26.6673V27.3333H13.334V29.3333ZM13.334 22.6667H23.334V20.6667H13.334V22.6667Z"
        />
    </svg>
    <svg v-else width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z"
            fill="#E2E5E7"
        />
        <path d="M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z" fill="#B0B7BD" />
        <path d="M37.5 17.5L30 10H37.5V17.5Z" fill="#CAD1D8" />
        <!--        <path
            d="M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z"
            fill="#F15642"
        />-->

        <!--        <text fill="black" x="5" y="35" font-size="12">{{ ext }}</text>-->

        <foreignObject width="100%" height="100%">
            <div
                :style="{ backgroundColor: getColorByExtension(ext) }"
                style="
                    margin-top: 16px;
                    font-size: 12px;
                    padding: 3px 4px;
                    font-weight: 600;
                    color: #fff;
                    border-radius: 3px;
                    width: max-content;
                "
                xmlns="http://www.w3.org/1999/xhtml"
            >
                {{ ext }}
            </div>
        </foreignObject>

        <!--        <path
            d="M7.94922 23.6841C7.94922 23.3541 8.20922 22.9941 8.62797 22.9941H10.9367C12.2367 22.9941 13.4067 23.8641 13.4067 25.5316C13.4067 27.1116 12.2367 27.9916 10.9367 27.9916H9.26797V29.3116C9.26797 29.7516 8.98797 30.0004 8.62797 30.0004C8.29797 30.0004 7.94922 29.7516 7.94922 29.3116V23.6841ZM9.26797 24.2529V26.7429H10.9367C11.6067 26.7429 12.1367 26.1516 12.1367 25.5316C12.1367 24.8329 11.6067 24.2529 10.9367 24.2529H9.26797Z"
            fill="white"
        />
        <path
            d="M15.3638 30.0002C15.0338 30.0002 14.6738 29.8202 14.6738 29.3815V23.704C14.6738 23.3452 15.0338 23.084 15.3638 23.084H17.6526C22.2201 23.084 22.1201 30.0002 17.7426 30.0002H15.3638ZM15.9938 24.304V28.7815H17.6526C20.3513 28.7815 20.4713 24.304 17.6526 24.304H15.9938Z"
            fill="white"
        />
        <path
            d="M23.7401 24.3833V25.972H26.2889C26.6489 25.972 27.0089 26.332 27.0089 26.6808C27.0089 27.0108 26.6489 27.2808 26.2889 27.2808H23.7401V29.3795C23.7401 29.7295 23.4914 29.9983 23.1414 29.9983C22.7014 29.9983 22.4326 29.7295 22.4326 29.3795V23.702C22.4326 23.3433 22.7026 23.082 23.1414 23.082H26.6501C27.0901 23.082 27.3501 23.3433 27.3501 23.702C27.3501 24.022 27.0901 24.382 26.6501 24.382H23.7401V24.3833Z"
            fill="white"
        />-->
        <!--        <path
            d="M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z"
            fill="#CAD1D8"
        />-->
    </svg>
</template>
<script>
export default {
    props: {
        ext: {
            type: String,
            default: ""
        }
    },
    name: "FileSimpleIcon",
    methods: {
        getColorByExtension(extension) {
            const extensionColors = {
                // Images
                jpg: "#9370DB",
                jpeg: "#9370DB",
                png: "#5D8AA8",
                gif: "#9370DB",
                svg: "#32CD32",
                webp: "#2B579A",

                // Font
                woff2: "#00008B",
                woff: "#1E90FF",

                // Audio
                mp3: "#FF0000",
                wav: "#1E90FF",
                flac: "#00008B",
                ogg: "#9932CC",

                // Video
                mp4: "#B22222",
                avi: "#A0522D",
                mov: "#C0C0C0",
                mkv: "#000000",

                // Docs
                pdf: "#FF4500",
                docx: "#2B579A",
                doc: "#2B579A",
                xlsx: "#217346",
                ppt: "#B22222",
                xls: "#217346",
                pptx: "#FFD700",
                txt: "#FFFFFF",

                // Archive
                zip: "#D2691E",
                rar: "#FF8C00",
                "7z": "#800080",

                // Exe
                exe: "#000000",
                msi: "#6A5ACD",
                sh: "#008000",
                bat: "#008000",

                // Code
                html: "#E34C26",
                htm: "#E34C26",
                css: "#2965F1",
                js: "#F0DB4F",
                py: "#3776AB",
                json: "#7CFC00",
                jar: "#3776AB",

                // Other
                torrent: "#008000",
                iso: "#808080",
                pac: "#808080"
            }

            const ext = extension.replace(".", "").toLowerCase()

            return extensionColors[ext] || "#808080"
        }
    }
}
</script>
